import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './Components/header/header.component';
import{ HeaderspineaComponent } from './Components/header-spinea/header-spinea.component';
import { FooterComponent } from './Components/footer/footer.component';
import { HomeComponent } from './Components/home/home.component';
import { FirstSelectionComponent } from './Components/first-selection/first-selection.component';
import { SecondSelectionComponent } from './Components/second-selection/second-selection.component';
import { ThirdSelectionComponent } from './Components/third-selection/third-selection.component';
import { FourthSelectionComponent } from './Components/fourth-selection/fourth-selection.component';
import { FinalPageComponent } from './Components/final-page/final-page.component';
import { ImagePopupComponent } from './Components/image-popup/image-popup.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { PdfDialogComponent } from './Components/pdf-dialog/pdf-dialog.component';
import { ImageDialogComponent } from './Components/HPDropDownChangeImage/image-dialog/image-dialog.component';
import { HPMountingPosComponent } from './Components/HPDropDownChangeImage/hpmounting-pos/hpmounting-pos.component';
import { FandialogComponent } from './Components/HPDropDownChangeImage/fandialog/fandialog.component';
import { RgFirstSelectionComponent } from './Components/RG/rg-first-selection/rg-first-selection.component';
import { RgSecondSelectionComponent } from './Components/RG/rg-second-selection/rg-second-selection.component';
import { RgFinalSelectionComponent } from './Components/RG/rg-final-selection/rg-final-selection.component';
import { HpaFirstSelectionComponent } from './Components/HPA/hpa-first-selection/hpa-first-selection.component';
import { HpaSecondSelectionComponent } from './Components/HPA/hpa-second-selection/hpa-second-selection.component';
import { HpaFinalSelectionComponent } from './Components/HPA/hpa-final-selection/hpa-final-selection.component';
import { BFirstSelectionComponent } from './Components/B/b-first-selection/b-first-selection.component';
import { BSecondSelectionComponent } from './Components/B/b-second-selection/b-second-selection.component';
import { BFinalSelectionComponent } from './Components/B/b-final-selection/b-final-selection.component';
import { ImagePopUpComponent } from './Components/B/image-pop-up/image-pop-up.component';
import { FFirstSelectionComponent } from './Components/F/f-first-selection/f-first-selection.component';
import { FSecondSelectionComponent } from './Components/F/f-second-selection/f-second-selection.component';
import { FFinalSelectionComponent } from './Components/F/f-final-selection/f-final-selection.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { RegistrationFormComponent } from './Components/registration-form/registration-form.component';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { AvatarModule } from 'primeng/avatar';
import { MessageService } from 'primeng/api';
import { RegistrationModalComponent } from './Components/CommonComponent/registration-modal/registration-modal.component';
import { PrivacyModalComponent } from './Components/CommonComponent/privacy-modal/privacy-modal.component';
// Update the path below to match the actual location and casing of FooterSpineaComponent
// For example, if the file is in './Components/footer-spinea/footer-spinea.component'
import { FooterSpineaComponent } from './Components/footer-spinea/footer-spinea.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ApimInterceptor } from './Services/interceptor/apim.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HeaderspineaComponent,
    FooterComponent,
    HomeComponent,
    FirstSelectionComponent,
    SecondSelectionComponent,
    ThirdSelectionComponent,
    FourthSelectionComponent,
    FinalPageComponent,
    ImagePopupComponent,
    PdfDialogComponent,
    ImageDialogComponent,
    HPMountingPosComponent,
    FandialogComponent,
    RgFirstSelectionComponent,
    RgSecondSelectionComponent,
    RgFinalSelectionComponent,
    HpaFirstSelectionComponent,
    HpaSecondSelectionComponent,
    HpaFinalSelectionComponent,
    BFirstSelectionComponent,
    BSecondSelectionComponent,
    BFinalSelectionComponent,
    ImagePopUpComponent,
    FFirstSelectionComponent,
    FSecondSelectionComponent,
    FFinalSelectionComponent,
    RegistrationFormComponent,
    RegistrationModalComponent,
    PrivacyModalComponent,
    FooterSpineaComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatExpansionModule,
    ToastModule,  // Add ToastModule here
    ButtonModule, // Add ButtonModule here
    RippleModule,
    AvatarModule,
    MatFormFieldModule,
    MatInputModule
  ],
  providers: [
    provideAnimationsAsync(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApimInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
